<template>
  <div>
    <div v-if="voucherInfoData && voucherInfoData.id > 0">
      <div class="container card voucher-info-card">
        <voucherDetail :voucher="voucherInfoData" />
        <loadingBar :useSlot="true" :isLoading="isLoading" />
      </div>
    </div>
    <div v-else-if="!isValidCode">
      <div class="error-content">
        <p>{{ $t('lookUpVoucher.invalidVoucherLinkMessage') }}</p>
        <p><a href="/look-up-voucher">{{ $t('introduction.pagename') }}</a></p>
      </div>
    </div>
    <inputConfirmModal
      ref="inputConfirmModal"
      :titleText="$t('lookUpVoucher.confirmAccessInfo')"
      :inputCaptionText="$t('lookUpVoucher.inputCaptionEmailPhone')"
      :inputHintText="$t('lookUpVoucher.inputHintEmail')"
      :btnConfirmText="$t('common.confirm')"
      @onConfirm="onConfirmEmail"
    />
  </div>
</template>
<script>

import { mapActions } from "vuex";
import functionUtils from "Utils/functionUtils";
import dateUtils from "Utils/dateUtils";
import { FOR_CONASI_TARGET } from 'Utils/constants'
import voucherDetail from "./VoucherDetail";
import InputConfirmModal from 'Components/InputConfirmModal'
export default {
  components: {
    voucherDetail,
    InputConfirmModal
  },
  data: () => ({
    isLoading: false,
    isValidCode: true,
    voucherInfoData: null,
    forConasi: FOR_CONASI_TARGET
  }),
  mounted() {
    this.getVoucherInfo(null)
  },
  methods: {
    onConfirmEmail: function (inputEmail) {
      this.getVoucherInfo(inputEmail);
    },
    getVoucherInfo: function(email) {
      this.isLoading = true;
      let routerParam = this.$route.params;
      let routerQuery = this.$route.query;
      let voucherId = routerParam && routerParam.id;
      let serial = routerParam && routerParam.serial;
      let phone = routerQuery && routerQuery.phone
      let filter = {
        params: {
          id: voucherId,
          serial: serial,
          email: email,
          phone: phone
        },
      };
      this.GET_VOUCHERS_INFO_WITH_CODE(filter)
        .then(
          function(res) {
            let data = res.data;
            let voucherObj = {
              id: data.id,
              serial: data.serial,
              status: data.status,
              expiredDate: this.getStartDateEVoucher(data.expired_date),
              value: data.workpiece ? data.workpiece.value : 0,
              description: data.workpiece.description,
              workpiece: data.workpiece,
              activeCode: data.activation_code,
              fromEntity: data.from_entity,
              issuanceType: data.workpiece.type,
              ownerVoucher: data.owner_voucher,
              activeCodeQr: data.activation_code_qr,
              toUserTransferred: data.to_user_transferred,
              issuanceImage: data.workpiece.image_url,
              conditionsOfUse: data.workpiece.conditions_of_use,
              details: data.workpiece.details,
              usageSites: data.usage_sites,
              isHidePrice: data.workpiece.is_hide_price,
            };
            this.voucherInfoData = voucherObj;
            this.$refs.inputConfirmModal.onHideModal()
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            if (error.response.status !== 404) {
              this.isValidCode = false
              this.showToast(this.$t(functionUtils.errorResponse(error.response)))
              this.$refs.inputConfirmModal.onHideModal()
            } else {
              if (email !== null) {
                this.showToast(this.$t(functionUtils.errorResponse(error.response)))
              }
              this.$refs.inputConfirmModal.onShowModal()
            }
            this.isLoading = false;
          }.bind(this)
        );
    },
    showToast: function (message) {
      this.$toast.clear();
      this.$toast.error(
        message,
        {
          position: "bottom-left",
          timeout: 1500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: true,
          rtl: false,
        }
      );
    },
    getStartDateEVoucher: function(date) {
      if (!functionUtils.isNull(date)) {
        return dateUtils.formatDate(
          date,
          dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
          dateUtils.STATIC_FORMAT_DATE
        );
      } else {
        return "";
      }
    },
    ...mapActions(["GET_VOUCHERS_INFO_WITH_CODE"]),
  },
};
</script>
<style lang="scss" scoped>
.voucher-info-card {
  padding: 1rem;
  margin-top: 30px;
  max-width: 800px;
}
.error-content {
  width: 100vw;
  height: 90vh;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px 30px;
}
</style>
